// extracted by mini-css-extract-plugin
export default {"button":"icon__button___Dme3p base__button___zT0JW"};